import { Component, OnDestroy, OnInit } from "@angular/core";
import { TransitionService } from "@uirouter/core";
import { EventService } from "../../event-service/event.service";
import { KeyboardService } from "../../keyboard/keyboard.service";

@Component({
  selector: "ab-undo-alert",
  templateUrl: "./undo.component.html",
})
export class UndoAlertComponent implements OnDestroy, OnInit {
  public action: any;
  public show: boolean;
  private undoRegisterActionSub: any;
  private undoHideSub: any;
  private unregisterKeydown: any;

  constructor(
    private $transitions: TransitionService,
    private eventService: EventService,
    private keyboardService: KeyboardService,
  ) {}

  public ngOnInit() {
    this.action = null;
    this.show = false;

    this.$transitions.onStart({}, () => {
      this.hide();
    });

    this.undoRegisterActionSub = this.eventService.subscribe(
      "undo:registerAction",
      (newAction: any) => {
        this.action = newAction;
        this.show = true;
        this.registerKeydown();
      },
    );

    this.undoHideSub = this.eventService.subscribe(
      "undo:hide",
      this.hide.bind(this),
    );
  }

  public hide() {
    this.show = false;
    if (this.unregisterKeydown) {
      this.unregisterKeydown();
    }
  }

  public undo() {
    if (!this.action) {
      return;
    }
    this.hide();
    this.action.undoObservable.subscribe();
    this.action = null;
  }

  public ngOnDestroy() {
    if (this.unregisterKeydown) {
      this.unregisterKeydown();
    }
    this.undoRegisterActionSub.unsubscribe();
    this.undoHideSub.unsubscribe();
  }

  private registerKeydown() {
    // Handle keyboard navigation with keydown events rather than keypress events.
    // This is because arrow keys do not fire keypress events, and it's nice to use
    // a single event type for all keyboard nav.
    // NB: Uses the keyboard service to allow us to capture keyboard events when
    // the user/browser focus is outside the group list.
    this.unregisterKeydown = this.keyboardService.onKeydown(
      (event: KeyboardEvent) => {
        // Don't trigger on CMD+/CTRL+ key combinations e.g. CMD+R to reload.
        if (event.metaKey || event.ctrlKey) {
          return;
        }

        if (event.code === "KeyU") {
          this.undo();
        }
        event.preventDefault();
      },
    );
  }
}
